import CustomTooltip from '../../shared/CustomTooltip';
import BlockIcon from '@mui/icons-material/Block';
import DoneIcon from '@mui/icons-material/Done';
import {
    Avatar,
    Box,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { selectFilteredClientData } from '../../../app/Slices/ClientFilterSlice';
import { useGetAllClientsQuery } from '../../../app/Slices/SevenDayApiSlice';
import { CustomChip } from '../../../layout/styledcomponents/CustomChip';
import GenericTable, { LinkType } from '../../shared/GenericTable';

export default function ClientComponent() {
    const { data: getClients } = useGetAllClientsQuery('/owners');
    const isMobile = useMediaQuery('(max-width: 770px)');
    const filterResults: any = useSelector(selectFilteredClientData);

    const theme = useTheme();

    const clients = getClients?.filter((val: any) => {
        if (
            // filterResults?.role === undefined &&
            filterResults?.status === undefined
        ) {
            return val;
        } else if (
            // filterResults?.role !== undefined &&
            filterResults?.status !== undefined
        ) {
            if (
                // filterResults?.role === 'All' &&
                filterResults?.status === 'All'
            ) {
                return val;
            } else if (
                // filterResults?.role !== 'All' &&
                filterResults?.status !== 'All'
            ) {
                return (
                    // val?.role
                    //     ?.toLowerCase()
                    //     ?.includes(filterResults?.role?.toLowerCase()) &&
                    val?.isActive ===
                    (filterResults?.status === 'enabled' ? true : false)
                );
            } else {
                return val;
            }
        } else {
            return val;
        }
    });

    const columns: MRT_ColumnDef<any>[] = [
        {
            accessorKey: 'name',
            header: 'Host',
            size: 500,
            mantineTableBodyCellProps: {
                style: {
                    padding: 0,
                },
            },
            Cell: ({ row }) => {
                const { original } = row;
                const name = original?.name;
                const email = original?.account?.email;
                const lastName = original?.lastName;

                return (
                    <List>
                        <ListItem sx={{ padding: '0!important' }}>
                            {!isMobile && (
                                <ListItemAvatar>
                                    <Avatar
                                        sx={{
                                            bgcolor: theme.palette.faded.main,
                                        }}
                                    >
                                        {name?.charAt(0)}
                                        {lastName?.charAt(0)}
                                    </Avatar>
                                </ListItemAvatar>
                            )}
                            <ListItemText
                                primary={<Typography>{name}</Typography>}
                                secondary={
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                        }}
                                    >
                                        {email}
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </List>
                );
            },
        },
        {
            accessorKey: 'lastLoginAt',
            header: 'Last Login',
            size: 180,

            Cell: ({ cell }) => {
                const value = cell.getValue<Date>();
                const date = value ? moment(value).format('DD/MM/YYYY') : '-';
                const time = value ? moment(value).format('h:mm a') : '';

                return (
                    <List>
                        <ListItem sx={{ padding: '0!important' }}>
                            <ListItemText
                                primary={<Typography>{date}</Typography>}
                                secondary={
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                        }}
                                    >
                                        {time}
                                    </Typography>
                                }
                            />
                        </ListItem>
                    </List>
                );
            },
        },
        {
            id: 'status',
            accessorFn: (row) => (row.isActive ? 'Enabled' : 'Disabled'),
            header: 'Status',
            size: 130,
            filterVariant: 'select',
            filterFn: (row, _columnId, filterValue) => {
                if (!filterValue) return true;
                return row.getValue<string>('isActive') === filterValue;
            },
            mantineFilterSelectProps: {
                data: [
                    { label: 'Enabled', value: 'Enabled' },
                    { label: 'Disabled', value: 'Disabled' },
                ],
                placeholder: 'Filter by Status',
                clearable: true,
            },
            Cell: ({ cell }) => {
                const isMobile = useMediaQuery('(max-width:600px)');
                const isIpad = useMediaQuery('(max-width:1024px)');
                const value = cell.getValue<string>() === 'Enabled';

                if (isMobile || isIpad) {
                    return value ? (
                        <CustomTooltip title='Enabled'>
                            <DoneIcon
                                sx={{ color: theme.palette.textAccent.main }}
                            />
                        </CustomTooltip>
                    ) : (
                        <CustomTooltip title='Disabled'>
                            <BlockIcon />
                        </CustomTooltip>
                    );
                }

                return (
                    <CustomChip
                        label={
                            <Typography
                                color={value ? 'green' : 'red'}
                                sx={{
                                    fontSize: '12px',
                                }}
                            >
                                {value ? 'Enabled' : 'Disabled'}
                            </Typography>
                        }
                        color={value ? 'green' : 'red'}
                        variant='outlined'
                    />
                );
            },
        },
    ];

    return (
        <Box sx={{ height: 700, width: '100%' }}>
            <GenericTable
                columns={columns}
                data={clients || []}
                tableName='7DAY-Clients-List'
                loading={!clients}
                linkType={LinkType.Client}
                linkState={{ name: 'viewClient' }}
            />
        </Box>
    );
}
